import { getEnvironmentFlags } from "../config/catalog";
import { calComLinkDev, calComLinkFI, calComLinkSE } from "../constants";
import { CountryCode } from "../types/common";
import { toE164OrDiallingCode } from "./toE164";

// Do NOT switch to Cal.com's `/embed` to drop the toolbar: that page waits on
// `@calcom/embed-core`'s postMessage handshake before it paints, so in a plain
// iframe it stays blank and nobody can book. Tried, reverted.
const BOOKING_URL_BY_COUNTRY: Readonly<Record<CountryCode, string>> = {
  [CountryCode.SE]: calComLinkSE,
  [CountryCode.FI]: calComLinkFI,
};

const bookingBaseUrl = (
  countryCode: CountryCode,
  environment: string | undefined,
): string =>
  getEnvironmentFlags(environment).realAdvisorCalendars
    ? BOOKING_URL_BY_COUNTRY[countryCode]
    : calComLinkDev;

// Must match the Cal.com booking question identifiers; Cal.com silently drops
// any param that doesn't.
const CUSTOMER_COMPANY_PARAM = "customerCompanyId";
const COMPANY_NAME_PARAM = "companyName";
const EMAIL_PARAM = "email";
const ATTENDEE_PHONE_PARAM = "attendeePhoneNumber";

export interface IWidgetBookingPrefill {
  customerCompanyId?: string | number | null;
  companyName?: string | null;
  email?: string | null;
  mobilePhoneNumber?: string | null;
  /** Only "production" books the real advisor calendars; anything else gets the dev one. */
  environment?: string;
}

export const resolveWidgetBookingUrl = (
  countryCode: CountryCode,
  prefill: IWidgetBookingPrefill = {},
): string => {
  // searchParams encodes "+" as %2B; a hand-built query would decode it as a space.
  const url = new URL(bookingBaseUrl(countryCode, prefill.environment));

  const params: Record<string, string | null | undefined> = {
    [CUSTOMER_COMPANY_PARAM]:
      prefill.customerCompanyId == null
        ? null
        : String(prefill.customerCompanyId).trim(),
    [COMPANY_NAME_PARAM]: prefill.companyName?.trim(),
    [EMAIL_PARAM]: prefill.email?.trim(),
    [ATTENDEE_PHONE_PARAM]: toE164OrDiallingCode(
      prefill.mobilePhoneNumber,
      countryCode,
    ),
  };

  for (const [key, value] of Object.entries(params)) {
    if (value) {
      url.searchParams.set(key, value);
    }
  }

  return url.toString();
};
